import { buildProcessedChildOrdersWithIndexByDisplayStatus, countDisplayGroups, isAllChildOrdersPendingPayment } from '@cart-services/utils/official-website-order-shipments'
import { getContactSupport } from '@cosign/utils/getContactSupport'
import { type ChildOrder } from '@hooks-api/types/dataModel/fpOrder'
import { Button } from '@pets-ui/Button/Button'
import { Divider } from '@pets-ui/Divider/Divider'
import { HStack } from '@pets-ui/HStack/HStack'
import { Paper } from '@pets-ui/Paper/Paper'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import { OrderInfo } from '../shared/Orders/OrderInfo'
import { DialogTrackingLabelStatus } from './DialogTrackingLabelStatus'
import { NoShipmentOrderItems } from './NoShipmentOrderItems'
import { OrderItemGroupOfficialWebsite } from './OrderItemGroupOfficialWebsite'

const styles = stylex.create({
  orderInfoSection: {
    borderWidth: 0,
    borderTopWidth: 0,
  },
})

interface AllOrdersProps {
  orders: ChildOrder[]
}

export function AllOrdersOfficialWebsite({ orders }: AllOrdersProps) {
  const { t } = useTranslation()
  const ordersWithStartIndex = buildProcessedChildOrdersWithIndexByDisplayStatus(orders)
  const isAllPendingOrders = isAllChildOrdersPendingPayment(orders)
  const showIndex = countDisplayGroups(ordersWithStartIndex) > 1
  return (
    <>
      {ordersWithStartIndex.map(({ order, orderItemGroups, ungroupedOrderItems, startIndex }) => {
        const ungroupedProductItems = ungroupedOrderItems.filter(item => item.order_item_type === 'product')
        const subshipType = order.subship_info?.type
        const { contactLink, openContact } = getContactSupport(order.project_code)
        return (
          <VStack gap={3} key={order.id}>
            {orderItemGroups.map((orderItemGroup, index) => (
              <OrderItemGroupOfficialWebsite
                key={orderItemGroup.groupNo}
                index={showIndex ? startIndex + index : undefined}
                orderItemGroup={orderItemGroup}
                subshipType={subshipType}
                displayStatus={order.display_status}
              />
            ))}
            {ungroupedProductItems.length > 0 && (
              <NoShipmentOrderItems
                orderItems={ungroupedProductItems}
                index={showIndex ? startIndex + orderItemGroups.length : undefined}
                isPendingOrder={isAllPendingOrders}
                subshipType={subshipType}
              />
            )}
            <Paper borderRadius={8}>
              <OrderInfo order={order} sectionStyle={styles.orderInfoSection} />
              <Divider />
              <HStack p={3} width="100%">
                <Button
                  variant="outlined"
                  color="grey"
                  size="small"
                  onClick={openContact}
                  disabled={!contactLink}
                >
                  {t('orderDetail.contactService', { defaultValue: '聯絡客服' })}
                </Button>
              </HStack>
            </Paper>
          </VStack>
        )
      })}
      <DialogTrackingLabelStatus />
    </>
  )
}
